export const environment = {
  title: "gspp-portal",
  environ: "DEV",
};
